import { render, staticRenderFns } from "./modal-wizard-tab.vue?vue&type=template&id=d3b33208"
import script from "./modal-wizard-tab.vue?vue&type=script&lang=js"
export * from "./modal-wizard-tab.vue?vue&type=script&lang=js"
import style0 from "./modal-wizard-tab.vue?vue&type=style&index=0&id=d3b33208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports